import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { WiseRecipient } from './wise.recipient.entity';

export class CreateWiseRecipientDto extends Omit(WiseRecipient, [...BaseEntityFieldsArray, 'recipientId', 'profileId']) {}
